/* eslint-disable no-duplicate-imports */
import { useEffect, useMemo, useState } from 'react'
import * as React from 'react'
import ReactDOM from 'react-dom'
import { View } from 'react-native'
import useScript from 'react-script-hook'
import styled from 'styled-components'
import { ErrorMessage } from '@flix/common/elements/status/ErrorMessage/ErrorMessage'
import { cursorPointer } from '@flix/common/style/webStyles'
import { canUseDOM } from '@flix/common/utils/canUseDOM'
import bugsnag from '../../services/bugsnag'
import messages from './messages'

const SCRIPT_LOAD_TIMEOUT = 4000

const BTN_HEIGHT = 39

const payPalOptions = new URLSearchParams()
payPalOptions.set('intent', 'subscription')
payPalOptions.set('vault', 'true') // Shows only funding sources that can start a subscription
payPalOptions.set('disable-funding', 'credit,card,bancontact') // No card payments

export const PayPalPlaceholder = styled(View)`
  width: 100%;
  height: ${BTN_HEIGHT}px;
  margin-bottom: ${(props) => props.theme.spacing.smedium}px;
`

const ButtonBlock = styled(View)`
  margin-bottom: ${(props) => props.theme.spacing.smedium}px;
  ${cursorPointer};
`

export const PayPalButton = ({ paypalClientId, ...props }) => {
  payPalOptions.set('client-id', paypalClientId)
  const [payPalLoading, error] = useScript({
    src: `https://www.paypal.com/sdk/js?${payPalOptions.toString()}`,
    checkForExisting: true,
    onerror: () => bugsnag.notify(new Error('Failed to load PayPal script')),
  })

  const payPalSDK = canUseDOM && window.paypal

  const PayPalButton = useMemo(
    () => (payPalSDK ? payPalSDK.Buttons.driver('react', { React, ReactDOM }) : null),
    [payPalLoading, payPalSDK], // eslint-disable-line react-hooks/exhaustive-deps
  )

  const [timedOut, setTimedOut] = useState(false)

  useEffect(() => {
    if (!PayPalButton) {
      const timeout = setTimeout(() => setTimedOut(true), SCRIPT_LOAD_TIMEOUT)
      return () => clearTimeout(timeout)
    }
  }, [PayPalButton])

  if (error || timedOut) {
    return (
      <ButtonBlock>
        <ErrorMessage {...messages.payPalLoadError} />
      </ButtonBlock>
    )
  }

  if (payPalLoading || !PayPalButton) return <PayPalPlaceholder />

  return (
    <ButtonBlock>
      <PayPalButton
        style={{
          color: 'silver',
          shape: 'rect',
          size: 'responsive',
          height: BTN_HEIGHT,
        }}
        {...props}
      />
    </ButtonBlock>
  )
}
